import {
  NumberInput as ChakraNumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

import PropTypes from 'prop-types';
import FormikFormControl from './FormikFormControl';

function NumberInput({
  label,
  helperText,
  errors,
  touched,
  flex,
  value,
  min,
  max,
  onChange,
  field,
  defaultValue,
  ...props
}) {
  return (
    <FormikFormControl
      label={label}
      helperText={helperText}
      errors={errors}
      touched={touched}
      flex={flex}
    >
      <ChakraNumberInput
        {...field}
        value={value}
        min={min}
        max={max}
        defaultValue={defaultValue}
        onChange={onChange}
        {...props}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </ChakraNumberInput>
    </FormikFormControl>
  );
}

NumberInput.defaultProps = {
  errors: null,
  touched: false,
  value: undefined,
  flex: '1',
  min: 0,
  max: undefined,
  onChange: () => {},
  field: null,
  defaultValue: undefined,
};

NumberInput.propTypes = {
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string.isRequired,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  flex: PropTypes.string,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  field: PropTypes.object,
  defaultValue: PropTypes.number,
};

export default NumberInput;
